export default __webpack_public_path__ + "static/media/E7A61E1A-00.c2cf3d5b.png";